/* eslint-disable no-undef */
/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';
import 'react-app-polyfill/ie11';
import 'core-js/es/string/starts-with';
import 'core-js/es/string/pad-start';
import 'core-js/es/string/repeat';
import 'core-js/es/array/find';
import 'core-js/es/symbol';
import '../../../polyfills';
import { withTheme } from 'styled-components';
import { isNil } from 'lodash';
import { renderToStaticMarkup } from 'react-dom/server';

const DEFAULT_VERTICAL_OFFSET_PX = 0;
const DEFAULT_HORIZONTAL_OFFSET_PX = -38;

export interface WaypointDialogProps {
  map: google.maps.Map;
  latLng: google.maps.LatLng;
  childComponent: JSX.Element;
  children?: JSX.Element;
  veritcalOffsetPx: number;
  visible: boolean;
}
class WaypointDialog extends React.PureComponent<WaypointDialogProps> {
  private dialogPosition: google.maps.LatLng;
  private overlayView: google.maps.OverlayView;
  private containerElement: HTMLDivElement | null = null;

  constructor(props: WaypointDialogProps, context: any) {
    super(props, context);
    this.dialogPosition = new google.maps.LatLng(0, 0);
    this.overlayView = new google.maps.OverlayView();
    this.overlayView.onAdd = this.onAdd.bind(this);
    this.overlayView.draw = this.draw.bind(this);
    this.overlayView.onRemove = this.onRemove.bind(this);
    this.overlayView.setMap(props.map);
  }

  public drawOverlayView(): void {
    this.dialogPosition = this.props.latLng;

    if (!isNil(this.overlayView)) {
      this.overlayView.draw();
    }
  }

  public componentDidMount(): void {
    this.drawOverlayView();
  }

  public componentDidUpdate(): void {
    this.drawOverlayView();
  }

  public componentWillUnmount(): void {
    if (!isNil(this.overlayView)) {
      this.overlayView.setMap(null);
    }
  }

  public onAdd(): void {
    const { childComponent } = this.props;
    this.containerElement = document.createElement('div');
    this.containerElement.style.position = 'absolute';
    this.containerElement.classList.add('map__aircraftcontainer');

    this.containerElement.innerHTML = renderToStaticMarkup(childComponent);
    const panes = this.overlayView.getPanes();
    if (panes) {
      panes.floatPane.appendChild(this.containerElement);
    }
  }

  public onRemove(): void {
    if (this.containerElement && this.containerElement.parentNode) {
      this.containerElement.parentNode.removeChild(this.containerElement);
    }
    this.containerElement = null;
  }
  public draw(): void {
    const { veritcalOffsetPx, visible } = this.props;
    const overlayProjection = this.overlayView.getProjection();
    if (this.containerElement && overlayProjection) {
      const point = overlayProjection.fromLatLngToDivPixel(this.dialogPosition);
      // Add the truncated horizontal x value of the map to a starting index for the z-index.
      // This will make the aircraft farthest right on the screen to show above any aircraft to the left.
      // eslint-disable-next-line no-bitwise
      const zIndex = 1700000;
      this.containerElement.style.left = `${point.x + DEFAULT_HORIZONTAL_OFFSET_PX}px`;
      this.containerElement.style.top = `${point.y - DEFAULT_VERTICAL_OFFSET_PX - veritcalOffsetPx}px`;
      this.containerElement.style.zIndex = zIndex.toString();
      this.containerElement.style.display = visible ? 'block' : 'none';
    }
  }

  public render(): React.ReactComponentElement<'div', {}> {
    const { children } = this.props;
    return <div>{children}</div>;
  }
}

export default withTheme(WaypointDialog);
